import styled from 'styled-components';

import {
  Flex,
  Text,
} from 'web-styled';

export const Item = styled(Flex).attrs({
  width: '100%',
  shrink: 0,
  padding: '15px',
  align: 'center',
})`
  color: ${props => props.theme.colors.link};
  border-bottom: 1px solid #ededed;

  &:hover {
    background: #fbfbfb;
  }

  &:last-of-type {
    border-bottom: none;
  }
`;

export const HeaderName = styled(Text)`
  font-size: 13px;
  color: #98a7ac;
  text-align: left;
`;

export const Sort = styled(Flex).attrs({
  flex: '0 0 18px',
  align: 'center',
})`
  height: 30px;
  opacity: 0.8;
  cursor: move;

  &:hover {
    opacity: 1;
  }
`;
